import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/agent/_work/2/s/front/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/agent/_work/2/s/front/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/agent/_work/2/s/front/layouts/empty.vue").then(m => m.default || m))
}